// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:53:59

export default {
  "id": "obby-the-legendary-dragon",
  "slug": "obby-the-legendary-dragon",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/32194919f11d457eb0ff0be9aa215efb-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/32194919f11d457eb0ff0be9aa215efb/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Obby The Legendary Dragon",
      "description": "Experience the thrill of an addictive pet-catching simulator, perfect for Pokémon fans! Explore diverse Roblox worlds and level up your heroes all in one exciting adventure.\nGather health, upgrade your hero, and unlock incredible new worlds to discover. Catch pets in battles, hatch them from cases and eggs, and trade or purchase them to build a team of powerful allies and friends. Earn money, climb the ranks, and enhance your Obby character with prestigious titles and upgrades!",
      "instructions": "PC control:\nAWSD - running;\nSpace - jump;\nTab - hide/show the cursor;\nMouse - turn.\n\nOn smartphones:",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "collect",
        "dragon",
        "pet",
        "roblox"
      ]
    },
    "zh-CN": {
      "title": "奥比传说之龙",
      "description": "体验这款令人上瘾的宠物捕捉模拟器的刺激，非常适合宝可梦粉丝！探索多样的Roblox世界，并在一次激动人心的冒险中提升你的英雄等级。\n收集健康值，升级你的英雄，解锁令人惊叹的新世界来探索。在战斗中捕捉宠物，从盒子或蛋中孵化它们，并通过交易或购买它们来组建一支强大的盟友和朋友团队。赚取金钱，攀登排行榜，并用声望称号和升级来增强你的Obby角色！",
      "instructions": "PC控制：\nAWSD - 跑步；\n空格 - 跳跃；\nTab - 隐藏/显示光标；\n鼠标 - 转身。\n\n在智能手机上：",
      "genres": [
        "冒险"
      ],
      "tags": [
        "收集",
        "龙",
        "宠物",
        "Roblox"
      ]
    },
    "zh-TW": {
      "title": "奧比：傳說龍王",
      "description": "體驗一個上癮的捕捉寵物模擬器的刺激，絕佳的寵物小將粉絲選擇！探索多元的Roblox世界，並在這場刺激的冒險中提升你的英雄等級。收集健康值，升級你的英雄，並解鎖令人驚艷的新世界來探索。在戰鬥中捕捉寵物，從箱子與蛋中孵化它們，並交易或購買它們來組建一支強大的盟友和朋友團隊。賺取金錢，攀登等級，並用聲譽顯赫的頭銜和升級來提升你的Obby角色！",
      "instructions": "PC 控制：\nAWSD - 跑步；\n空格鍵 - 跳躍；\nTab 鍵 - 隱藏/顯示滑鼠指針；\n滑鼠 - 轉向。\n\n在智慧型手機上：",
      "genres": [
        "冒險"
      ],
      "tags": [
        "收集",
        "龍",
        "寵物",
        "Roblox"
      ]
    },
    "zh-HK": {
      "title": "奧比 傳說龍王",
      "description": "體驗一個令人上癮的收獲寵物模擬器的刺激感，適合寵物小精靈粉絲！探索多樣化的Roblox世界，並在這個充滿趣味的冒險中提升你的英雄等級。\n收集健康值，提升你的英雄，解鎖令人驚艷的新世界來探索。在戰鬥中收獲寵物，從盒子及蛋中孵化它們，並進行交易或購買它們來建立一支強大的盟友和朋友團隊。賺取金錢，攀登排名，並使用聲望高的頭銜和升級來提升你的Obby角色！",
      "instructions": "PC控制：\nAWSD - 跑步；\n空格 - 跳躍；\nTab - 隱藏/顯示滑鼠光標；\n滑鼠 - 轉向。\n\n在智能手機上：",
      "genres": [
        "冒險"
      ],
      "tags": [
        "收集",
        "龍",
        "寵物",
        "Roblox"
      ]
    },
    "ja": {
      "title": "オビー・伝説の竜",
      "description": "魅力的ペット捕獲シミュレーターの魅力を体験しよう、ポケモンファン必見！多様なRobloxの世界を探索し、ヒーローをレベルアップする興味深い冒険を一挙に楽しむ。\n\n健康を集め、ヒーローをアップグレードし、発見するための素晴らしい新しい世界を解鍵しよう。戦闘でペットを捕獲し、ケースや卵から孵化させ、取引や購入して強力な同盟者と友達のチームを築こう。お金を稼ぎ、ランキングを上げ、ステイタスの高いタイトルとアップグレードでObbyキャラクターを強化しよう！",
      "instructions": "PCコントロール：\nAWSD - 走行；\nスペース - 跳びる；\nタブ - カーソルの隠し/表示；\nマウス - 動き。\n\nスマートフォンでは：",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "収集",
        "ドラゴン",
        "ペット",
        "ロブロックス"
      ]
    },
    "ko": {
      "title": "오비 전설의 드래곤",
      "description": "애니메이션宠物 포획 시뮬레이터의 흥미진진한 경험을 즐겨보세요! 포켓몬 팬들에게도 완벽한 로빅스 세계를 탐험하고 영웅들을 레벨업하세요. 건강을 모으고 영웅을 업그레이드하고, 새로운 세계를 발견할 수 있는 흥미로운 모험을 즐겨보세요.\n\n전투에서 펫을 잡고, 상자와 알에서孵化하여 교환하거나 구매하여 강력한 동맹자와 친구의 팀을 구축하세요. 돈을 벌고 등級을 올려, 오비 캐릭터를 명예로운 제목과 업그레이드로 강화하세요!",
      "instructions": "PC 조이스틱:\nAWSD - 달리기;\n공백키 - 점프;\nTab - 커서 숨기기/보이기;\n마우스 - 회전.\n\n스마트폰에서:",
      "genres": [
        "모험"
      ],
      "tags": [
        "수집",
        "드래곤",
        "펫",
        "로블록스"
      ]
    },
    "fr": {
      "title": "Obby Le Dragon Légendaire",
      "description": "Expérience du frisson d'un simulateur de capture de pets accrocheur, parfait pour les fans de Pokémon ! Explorez divers mondes Roblox et faites évoluer vos héros dans une aventure captivante. Récoltez de la santé, améliorez votre héros et débloquez de nouveaux mondes à découvrir. Capturez des pets dans des batailles, les éclore à partir de boîtes et d'œufs, et échangez ou achetez pour constituer une équipe de puissants alliés et amis. Gagnez de l'argent, montez dans les rangs et améliorez votre personnage Obby avec des titres prestigieux et des mises à niveau !",
      "instructions": "Contrôle sur PC :\nAWSD - course ;\nEspace - saut ;\nTab - cacher/afficher le curseur ;\nSouris - tourner.\n\nSur les smartphones :",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "collecter",
        "dragon",
        "animal de compagnie",
        "roblox"
      ]
    }
  }
};
